var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnRadioSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn_radio_selected",
    transform: "translate(-30 -524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1157",
    "data-name": "Rectangle 1157",
    transform: "translate(30 524)",
    fill: "#49a8fb",
    stroke: "#49a8fb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22027",
    "data-name": "Path 22027",
    d: "M26.907,3.836c1.114.99,2.6,2.351,2.6,2.351A34.969,34.969,0,0,1,36.435,0l.248.742c-1.237.742-4.95,4.95-6.311,8.662,0,0-3.836-3.712-4.579-4.579l1.114-.99Z",
    transform: "translate(8.207 528)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRadioSelected);
export default __webpack_public_path__ + "static/media/btn_radio_selected.ae5961382db0575f9b99a0c70af3525d.svg";
export { ForwardRef as ReactComponent };